import * as React from "react"

/**
 * THIS IS A GENERATED FILE, DO NOT MODIFY MANUALLY.
 * Modify .svg in src/assets/icons/ and generate code again with 'yarn generate-icons'.
 */
export const NutritionIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
      {...props}
    >
      <defs>
        <clipPath id="prefix__a">
          <path d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefix__a)">
        <path d="M37.904 4.483a1.21 1.21 0 01-.014.974 1.311 1.311 0 01-.737.679l-6.049 2.293-1.073 4.9a10.47 10.47 0 012.607.933 2.541 2.541 0 011.5 2.085 1.934 1.934 0 01-.029.336l-2.58 23.056a3.219 3.219 0 01-1.405 2.365 14.56 14.56 0 01-8.07 2.211 14.56 14.56 0 01-8.073-2.212 3.219 3.219 0 01-1.405-2.365l-2.545-23.056a1.882 1.882 0 01-.027-.336 2.541 2.541 0 011.5-2.081 10.683 10.683 0 012.655-.946 35.819 35.819 0 017.912-.783 41.749 41.749 0 015.324.323l1.244-5.632a1.293 1.293 0 01.813-.905l6.7-2.543a1.367 1.367 0 011.752.704zm-11.09 10.865a39.553 39.553 0 00-4.742-.272 33.212 33.212 0 00-7.26.707 9.14 9.14 0 00-1.738.564 9.222 9.222 0 001.738.564 33.212 33.212 0 007.26.707 39.794 39.794 0 004.259-.216l.483-2.054zm.783 4.465a42.138 42.138 0 01-5.525.348 35.819 35.819 0 01-7.912-.783q-.59-.139-1.167-.323l2.249 20.416a.718.718 0 00.274.547 11.794 11.794 0 006.538 1.754 11.794 11.794 0 006.538-1.754.709.709 0 00.274-.547l2.285-20.416q-.576.184-1.167.323-1.181.274-2.387.432zm-15-3.76a.043.043 0 01.013.015zm18.95 0l-.013.015a.043.043 0 01.014-.016zm-.48.295a8.831 8.831 0 00-1.62-.534l-.266 1.131.148-.033a9.222 9.222 0 001.739-.565z" />
      </g>
    </svg>
  )
}
